<app-side-menu>
  <div class="agendamentos-container">
    <div class="row mb-3">
      <div class="col-12">
        <h1 class="page-title">
          <i class="fas fa-calendar-alt me-2"></i>
          {{ b2bOnly ? 'Agendamentos B2B' : 'Agendamentos' }}
        </h1>
        <p class="text-muted">
          {{ b2bOnly
            ? 'Apenas agendas com agendamento externo habilitado são exibidas. Solicitações de oficinas parceiras aguardam análise abaixo.'
            : 'Selecione um dia e horário para agendar' }}
        </p>
      </div>
    </div>

    <!-- Fila operacional B2B: parceiros + solicitações de guincho -->
    <div class="row mb-3" *ngIf="b2bOnly">
      <div class="col-12">
        <div class="card shadow-sm partner-pending-card">
          <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
            style="background-color: #3A4D56; color: #fff;">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <ul class="nav nav-pills ops-queue-tabs mb-0">
                <li class="nav-item">
                  <button type="button" class="nav-link"
                    [class.active]="opsQueueTab === 'parceiros'"
                    (click)="selectOpsQueueTab('parceiros')">
                    <i class="fas fa-building me-1"></i> Aguardando confirmação
                    <span class="badge bg-warning text-dark ms-1" *ngIf="partnerPendingAppointments.length">
                      {{ partnerPendingAppointments.length }}
                    </span>
                    <span class="badge bg-danger ms-1" *ngIf="partnerPendingNewCount" title="Novos nas últimas 24h">
                      {{ partnerPendingNewCount }} novo(s)
                    </span>
                  </button>
                </li>
                <li class="nav-item">
                  <button type="button" class="nav-link"
                    [class.active]="opsQueueTab === 'guincho'"
                    (click)="selectOpsQueueTab('guincho')">
                    <i class="fas fa-truck-pickup me-1"></i> Solicitações de guincho
                    <span class="badge bg-info text-dark ms-1" *ngIf="guinchoRequests.length">
                      {{ guinchoRequests.length }}
                    </span>
                    <span class="badge bg-danger ms-1" *ngIf="guinchoNewCount" title="Novos nas últimas 24h">
                      {{ guinchoNewCount }} novo(s)
                    </span>
                  </button>
                </li>
              </ul>
            </div>
            <div class="d-flex gap-2 align-items-center">
              <label class="mb-0 small text-white-50" *ngIf="opsQueueTab === 'guincho'">
                <input type="checkbox" class="form-check-input me-1"
                  [(ngModel)]="includeClosedGuincho"
                  (change)="loadGuinchoRequests()">
                Incluir finalizados
              </label>
              <button type="button" class="btn btn-sm btn-light"
                (click)="opsQueueTab === 'guincho' ? loadGuinchoRequests() : loadPartnerPendingAppointments()"
                [disabled]="loadingPartnerPending || loadingGuinchoRequests">
                <i class="fas fa-sync-alt" [class.fa-spin]="loadingPartnerPending || loadingGuinchoRequests"></i>
                Atualizar
              </button>
            </div>
          </div>
          <div class="card-body">
            <!-- Parceiros -->
            <ng-container *ngIf="opsQueueTab === 'parceiros'">
            <div *ngIf="loadingPartnerPending || (loadingSchedules && partnerPendingAppointments.length === 0 && !partnerPendingError)"
              class="text-center text-muted py-3">
              <i class="fas fa-spinner fa-spin me-2"></i>Carregando solicitações...
            </div>
            <div *ngIf="!loadingPartnerPending && !loadingSchedules && partnerPendingError" class="alert alert-danger mb-0">
              {{ partnerPendingError }}
            </div>
            <div *ngIf="!loadingPartnerPending && !loadingSchedules && !partnerPendingError && partnerPendingAppointments.length === 0"
              class="text-muted mb-0">
              Nenhum agendamento (base ou parceiro) aguardando confirmação.
            </div>
            <div class="table-responsive" *ngIf="partnerPendingAppointments.length > 0">
              <table class="table table-sm table-hover align-middle mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th>Data</th>
                    <th>Horário</th>
                    <th>Placa</th>
                    <th>Condutor</th>
                    <th>Oficina</th>
                    <th>Observação</th>
                    <th>Solicitado por</th>
                    <th class="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let app of partnerPendingAppointments" [class.table-warning]="isNewAppointment(app)">
                    <td class="text-nowrap">
                      <span class="badge bg-danger" *ngIf="isNewAppointment(app)">Novo</span>
                      <span class="badge bg-primary" *ngIf="isBaseB2bPending(app)">Base</span>
                      <span class="badge bg-secondary" *ngIf="!isBaseB2bPending(app)">Parceiro</span>
                    </td>
                    <td>{{ formatAppointmentDate(app) }}</td>
                    <td>{{ formatAppointmentTime(app.StartTime) }} – {{ formatAppointmentTime(app.EndTime) }}</td>
                    <td><code>{{ app.Plate || '—' }}</code></td>
                    <td>{{ app.DriverName || '—' }}</td>
                    <td>
                      <div class="fw-semibold">{{ providerNameOf(app) }}</div>
                      <small class="text-muted">{{ app.Subject }}</small>
                    </td>
                    <td>
                      <span class="text-muted small" [title]="app.PartnerNotes || ''">
                        {{ app.PartnerNotes || '—' }}
                      </span>
                    </td>
                    <td>
                      <small>{{ app.CreatedBy || '—' }}</small>
                      <div class="text-muted" style="font-size:0.7rem" *ngIf="app.CreatedAt">
                        {{ app.CreatedAt | date:'dd/MM HH:mm' }}
                      </div>
                    </td>
                    <td class="text-end text-nowrap">
                      <button type="button" class="btn btn-sm btn-outline-info me-1"
                        (click)="openAppointmentDetailsModal(app)"
                        title="Visualizar detalhes">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-primary me-1"
                        (click)="openPartnerReschedule(app)"
                        [disabled]="partnerActionId === app.Id"
                        title="Alterar oficina, data ou horário">
                        <i class="fas fa-calendar-alt"></i> Reagendar
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary me-1"
                        *ngIf="!isBaseB2bPending(app)"
                        (click)="openPartnerReassign(app)"
                        [disabled]="partnerActionId === app.Id"
                        title="Atalho: reagendar e trocar oficina">
                        <i class="fas fa-exchange-alt"></i> Trocar parceiro
                      </button>
                      <button type="button" class="btn btn-sm btn-success me-1"
                        (click)="confirmPartnerBooking(app)"
                        [disabled]="partnerActionId === app.Id"
                        title="Confirmar após contato com a oficina">
                        <i class="fas fa-check"></i> Confirmar
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-danger"
                        (click)="rejectPartnerBooking(app)"
                        [disabled]="partnerActionId === app.Id"
                        title="Recusar solicitação">
                        <i class="fas fa-times"></i> Recusar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </ng-container>

            <!-- Guincho -->
            <ng-container *ngIf="opsQueueTab === 'guincho'">
            <div *ngIf="loadingGuinchoRequests" class="text-center text-muted py-3">
              <i class="fas fa-spinner fa-spin me-2"></i>Carregando guinchos...
            </div>
            <div *ngIf="!loadingGuinchoRequests && guinchoRequestsError" class="alert alert-danger mb-0">
              {{ guinchoRequestsError }}
            </div>
            <div *ngIf="!loadingGuinchoRequests && !guinchoRequestsError && guinchoRequests.length === 0"
              class="text-muted mb-0">
              Nenhuma solicitação de guincho em andamento.
            </div>
            <div class="table-responsive" *ngIf="guinchoRequests.length > 0">
              <table class="table table-sm table-hover align-middle mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th>Status</th>
                    <th>Data</th>
                    <th>Horário</th>
                    <th>Placa</th>
                    <th>Condutor</th>
                    <th>Região / obs.</th>
                    <th>Solicitado por</th>
                    <th class="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let app of guinchoRequests" [class.table-warning]="isNewAppointment(app)">
                    <td class="text-nowrap">
                      <span class="badge bg-danger" *ngIf="isNewAppointment(app)">Novo</span>
                      <span class="badge bg-info text-dark">Guincho</span>
                    </td>
                    <td><span class="badge bg-secondary">{{ app.Status || '—' }}</span></td>
                    <td>{{ formatAppointmentDate(app) }}</td>
                    <td>{{ formatAppointmentTime(app.StartTime) }} – {{ formatAppointmentTime(app.EndTime) }}</td>
                    <td><code>{{ app.Plate || '—' }}</code></td>
                    <td>{{ app.DriverName || '—' }}</td>
                    <td>
                      <span class="text-muted small" [title]="app.PartnerNotes || ''">
                        {{ app.PartnerNotes || '—' }}
                      </span>
                    </td>
                    <td>
                      <small>{{ app.CreatedBy || '—' }}</small>
                      <div class="text-muted" style="font-size:0.7rem" *ngIf="app.CreatedAt">
                        {{ app.CreatedAt | date:'dd/MM HH:mm' }}
                      </div>
                    </td>
                    <td class="text-end text-nowrap">
                      <button type="button" class="btn btn-sm btn-outline-info me-1"
                        (click)="openAppointmentDetailsModal(app)" title="Detalhes e histórico">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-primary me-1"
                        *ngIf="canEditConfirmedAppointment(app)"
                        (click)="openPartnerReschedule(app)"
                        [disabled]="partnerActionId === app.Id"
                        title="Reagendar / corrigir (exceto veículo)">
                        <i class="fas fa-calendar-alt"></i> Corrigir
                      </button>
                      <button type="button" class="btn btn-sm btn-success me-1"
                        *ngIf="app.Status === 'AguardandoAnalise' || app.Status === 'Aguardando Análise'"
                        (click)="confirmPartnerBooking(app)"
                        [disabled]="partnerActionId === app.Id">
                        <i class="fas fa-check"></i> Confirmar
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-warning me-1"
                        *ngIf="canCreateBudgetFromAppointment(app)"
                        (click)="createBudgetFromAppointment(app)"
                        title="Abrir orçamento de guincho">
                        <i class="fas fa-file-invoice-dollar"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <!-- Seletor de Agenda -->
      <div class="col-12 mb-1">
        <div class="d-flex align-items-center gap-2">
          <label class="form-label me-2 mb-0 fw-semibold" for="scheduleSelect">Selecione a Agenda</label>
          <select id="scheduleSelect" class="form-select schedule-select"
            [disabled]="loadingSchedules || !schedules.length" [(ngModel)]="selectedScheduleId"
            (ngModelChange)="onScheduleChange($event)">
            <option [ngValue]="null" disabled>Escolha...</option>
            <option *ngFor="let s of schedules" [ngValue]="s.Id">{{ s.Name || ('Agenda #' + s.Id) }}</option>
          </select>
          <button type="button" class="btn search-appointment-btn" *ngIf="selectedScheduleId !== null"
            (click)="openSearchModal()" [disabled]="loadingSchedules || !schedules.length"
            title="Buscar agendamento por CPF/CNPJ">
            <i class="fas fa-search"></i>
          </button>
          <button type="button" class="btn btn-outline-primary external-link-btn"
            *ngIf="selectedScheduleId !== null && selectedSchedule?.CanExternalLink"
            (click)="openExternalLinkModal()"
            title="Gerar Link de Agendamento Externo">
            <i class="fas fa-link me-2"></i>
            Gerar Link para Agendamento Externo
          </button>
          <span *ngIf="loadingSchedules" class="text-muted small">Carregando…</span>
          <span *ngIf="loadingExcludedDays" class="text-muted small">
            <i class="fas fa-spinner fa-spin me-1"></i>Carregando dias excluídos…
          </span>
        </div>
        <div *ngIf="schedulesError" class="text-danger small mt-1">{{ schedulesError }}</div>
        <div *ngIf="!loadingSchedules && !schedulesError && !schedules.length" class="text-muted small mt-1">Nenhuma
          agenda encontrada.</div>
      </div>

      <div class="col-12" *ngIf="showCalendar">
        <div class="alert alert-info">
          <i class="fas fa-info-circle me-2"></i>
          Visualize em modo <strong>Mensal</strong>, <strong>Semanal</strong> ou <strong>Dashboard</strong>.
          Clique em um dia para ver os horários disponíveis.
        </div>
      </div>

      <!-- Mensagem quando nenhuma agenda está selecionada -->
      <div class="col-12"
        *ngIf="!showCalendar && !loadingExcludedDays && !loadingSchedules && selectedScheduleId === null">
        <div class="alert alert-warning">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Por favor, selecione uma agenda para visualizar o calendário de agendamentos.
        </div>
      </div>

      <div class="col-12" *ngIf="showCalendar">
        <!-- Toggle de modo de visualização -->
        <div class="preview-mode-toggle btn-group mb-3" role="group">
          <input type="radio" class="btn-check" name="previewMode" id="monthlyMode" [value]="'monthly'"
            [(ngModel)]="previewMode" (change)="onPreviewModeChange()" autocomplete="off">
          <label class="btn btn-outline-primary" for="monthlyMode">
            <i class="fas fa-calendar-alt me-2"></i>
            Mensal
          </label>

          <input type="radio" class="btn-check" name="previewMode" id="weeklyMode" [value]="'weekly'"
            [(ngModel)]="previewMode" (change)="onPreviewModeChange()" autocomplete="off">
          <label class="btn btn-outline-primary" for="weeklyMode">
            <i class="fas fa-calendar-week me-2"></i>
            Semanal
          </label>

          <input type="radio" class="btn-check" name="previewMode" id="dashboardMode" [value]="'dashboard'"
            [(ngModel)]="previewMode" (change)="onPreviewModeChange()" autocomplete="off">
          <label class="btn btn-outline-primary" for="dashboardMode">
            <i class="fas fa-chart-pie me-2"></i>
            Dashboard
          </label>
        </div>

        <!-- Visualização Mensal -->
        <div class="calendar-preview" *ngIf="previewMode === 'monthly'">
          <!-- Navegação de Mês/Ano -->
          <div class="month-controls d-flex align-items-center gap-2 mb-3">
            <button type="button" class="btn btn-light" (click)="prevMonth()" aria-label="Mês anterior">
              <i class="fas fa-chevron-left"></i>
            </button>
            <div class="month-label fw-semibold">
              {{ getMonthName(viewMonth) }} {{ viewYear }}
            </div>
            <button type="button" class="btn btn-light" (click)="nextMonth()" aria-label="Próximo mês">
              <i class="fas fa-chevron-right"></i>
            </button>
            <div class="d-flex align-items-center ms-2">
              <span class="text-muted me-2">Ano</span>
              <select class="form-select year-select" [(ngModel)]="viewYear" (ngModelChange)="onYearChange($event)">
                <option *ngFor="let y of yearsList" [value]="y">{{ y }}</option>
              </select>
            </div>
          </div>
          <div class="calendar-grid">
            <div class="calendar-day" *ngFor="let day of previewDays" [class.disabled]="!day.available"
              [class.selected]="selectedPreviewDay === day" (click)="selectPreviewDay(day)">
              <div class="day-header">
                <span class="day-name">{{ day.dayName }}</span>
                <span class="day-number">{{ day.dayNumber }}</span>
              </div>
              <div class="day-month">{{ day.monthShort }}</div>
              <div class="day-meta">
                <span class="day-badge day-badge--appointments" *ngIf="day.appointmentsCount > 0">
                  <i class="fas fa-calendar-day me-1"></i>
                  {{ day.appointmentsCount }} ag.
                </span>
                <span class="day-badge day-badge--available" *ngIf="day.appointmentsCount === 0 && day.available">
                  Disponível
                </span>
                <span class="day-badge day-badge--unavailable" *ngIf="!day.available">
                  Indisponível
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualização Semanal -->
        <div class="calendar-preview" *ngIf="previewMode === 'weekly'">
          <div class="weekly-controls d-flex justify-content-between align-items-center mb-2">
            <button type="button" class="btn btn-light" (click)="prevWeek()">
              <i class="fas fa-chevron-left"></i>
            </button>
            <div class="week-range text-muted fw-semibold">
              {{ weeklyDays[0].fullDate | date: 'dd/MM' }} - {{ weeklyDays[6].fullDate | date: 'dd/MM/yyyy' }}
            </div>
            <button type="button" class="btn btn-light" (click)="nextWeek()">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
          <div class="calendar-grid weekly-grid">
            <div class="calendar-day" *ngFor="let day of weeklyDays" [class.disabled]="!day.available"
              [class.selected]="selectedPreviewDay === day" (click)="selectPreviewDay(day)">
              <div class="day-header">
                <span class="day-name">{{ day.dayName }}</span>
                <span class="day-number">{{ day.dayNumber }}</span>
              </div>
              <div class="day-month">{{ day.monthShort }}</div>
              <div class="day-meta">
                <span class="day-badge day-badge--appointments" *ngIf="day.appointmentsCount > 0">
                  <i class="fas fa-calendar-day me-1"></i>
                  {{ day.appointmentsCount }} ag.
                </span>
                <span class="day-badge day-badge--available" *ngIf="day.appointmentsCount === 0 && day.available">
                  Disponível
                </span>
                <span class="day-badge day-badge--unavailable" *ngIf="!day.available">
                  Indisponível
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualização Dashboard -->
        <div class="calendar-preview" *ngIf="previewMode === 'dashboard'">
          <div class="alert alert-info">
            <i class="fas fa-info-circle me-2"></i>
            Dashboard de agendamentos da agenda selecionada.
          </div>

          <app-loading [show]="dashboardLoading" message="Carregando dashboard..."></app-loading>

          <div *ngIf="dashboardError" class="alert alert-danger">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ dashboardError }}
          </div>

          <div *ngIf="!dashboardLoading && !dashboardError && dashConfig">
            <app-dash-component [config]="dashConfig"></app-dash-component>
          </div>
        </div>
      </div>

      <!-- Seção de Horários Disponíveis -->
      <div class="col-12" *ngIf="showTimeSlots && selectedPreviewDay">
        <div class="card shadow-sm">
          <div class="card-header text-white d-flex justify-content-between align-items-center"
            style="background-color: #3A4D56;">
            <h5 class="mb-0">
              <i class="fas fa-calendar-day me-2"></i>
              {{ selectedPreviewDay.fullDate | date: 'EEEE, dd/MM/yyyy' }}
            </h5>
            <button type="button" class="btn btn-light btn-sm" (click)="backToCalendar()" title="Fechar">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="card-body">
            <!-- Loading -->
            <div *ngIf="loadingDayAvailability" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
              <p class="mt-3 text-muted">Verificando disponibilidade...</p>
            </div>

            <!-- Dia Disponível -->
            <div *ngIf="selectedPreviewDay.available && !loadingDayAvailability">
              <div class="alert alert-success mb-4 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div>
                  <i class="fas fa-check-circle me-2"></i>
                  <strong>Dia Disponível!</strong>
                  <span *ngIf="!showNewAppointmentSection"> Clique em "Novo Agendamento" para selecionar um horário.</span>
                  <span *ngIf="showNewAppointmentSection"> Selecione um horário abaixo para agendar.</span>
                </div>

                <button type="button" class="btn btn-primary btn-sm" *ngIf="!showNewAppointmentSection"
                  (click)="openNewAppointmentSection()">
                  <i class="fas fa-plus me-2"></i>
                  Novo Agendamento
                </button>

                <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="showNewAppointmentSection"
                  (click)="closeNewAppointmentSection()">
                  <i class="fas fa-eye-slash me-2"></i>
                  Ocultar horários
                </button>
              </div>

              <div *ngIf="showNewAppointmentSection">
                <h6 class="mb-3">Horários Disponíveis:</h6>
                <div class="row g-3">
                  <div class="col-md-4 col-lg-3" *ngFor="let slot of selectedPreviewDay.timeSlots">
                    <div class="card time-slot-card h-100" [class.selected]="selectedTimeSlot === slot"
                      (click)="chooseTimeSlot(slot)">
                      <div class="card-body text-center">
                        <div class="slot-time mb-2">
                          <i class="fas fa-clock me-2 text-primary"></i>
                          <strong>{{ slot.start }} - {{ slot.end }}</strong>
                        </div>
                        <div class="slot-capacity" *ngIf="slot.capacity !== undefined">
                          <i class="fas fa-users me-1 text-success"></i>
                          <span class="badge bg-success">
                            {{ slot.capacity }} {{ slot.capacity === 1 ? 'vaga' : 'vagas' }}
                          </span>
                          <div *ngIf="slot.totalCapacity" class="text-muted small mt-1">
                            {{ slot.bookedCount }}/{{ slot.totalCapacity }} ocupadas
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Área de Agendamento para Cliente -->
                <div class="schedule-area mt-4" *ngIf="selectedTimeSlot">
                  <div class="card bg-light">
                    <div class="card-body">
                      <h6 class="card-title mb-3">
                        <i class="fas fa-user-plus me-2"></i>
                        Realizar Agendamento
                      </h6>

                      <!-- Seleção de Cliente -->
                      <div class="mb-3" *ngIf="!showCustomerTable">
                        <label class="form-label">Cliente</label>
                        <div class="d-flex gap-2">
                          <div class="flex-grow-1">
                            <div *ngIf="!selectedCustomer" class="form-control text-muted" style="cursor: pointer;"
                              (click)="toggleCustomerTable()">
                              <i class="fas fa-search me-2"></i>
                              Clique para selecionar um cliente
                            </div>
                            <div *ngIf="selectedCustomer" class="selected-customer-display">
                              <div class="d-flex justify-content-between align-items-center p-2 border rounded bg-white">
                                <div>
                                  <strong>{{ selectedCustomer.name }}</strong>
                                  <div class="text-muted small">
                                    {{ selectedCustomer.documentNumber }} - {{ selectedCustomer.email }}
                                  </div>
                                </div>
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                  (click)="clearCustomerSelection()">
                                  <i class="fas fa-times"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <button type="button" class="btn btn-primary" (click)="toggleCustomerTable()"
                            *ngIf="!selectedCustomer">
                            <i class="fas fa-users me-2"></i>
                            Selecionar Cliente
                          </button>
                          <button type="button" class="btn btn-success"
                            [disabled]="!selectedCustomer || creatingAppointment || (isB2bBookingFlow && !b2bBooking.canConfirm)"
                            (click)="scheduleForClient()">
                            <i class="fas fa-spinner fa-spin me-2" *ngIf="creatingAppointment"></i>
                            <i class="fas fa-save me-2" *ngIf="!creatingAppointment"></i>
                            {{ creatingAppointment ? 'Agendando...' : 'Confirmar' }}
                          </button>
                        </div>
                      </div>

                      <app-b2b-appointment-booking-form
                        *ngIf="isB2bBookingFlow && selectedCustomer && !showCustomerTable">
                      </app-b2b-appointment-booking-form>

                      <!-- Tabela de Clientes -->
                      <div *ngIf="showCustomerTable" class="customer-table-container">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h6 class="mb-0">Selecione um Cliente</h6>
                          <button type="button" class="btn btn-sm btn-secondary" (click)="toggleCustomerTable()">
                            <i class="fas fa-times me-2"></i>
                            Fechar
                          </button>
                        </div>

                        <div *ngIf="loadingCustomers || customers.length > 0">
                          <app-table [title]="customerTableTitle" [data]="customers" [columns]="customerColumns"
                            [loading]="loadingCustomers"
                            [showSearch]="true" [searchPlaceholder]="'Buscar por nome, documento, email...'"
                            [clickable]="true" [actions]="customerTableActions" [disablePagination]="false"
                            (rowClick)="onCustomerSelect($event)">
                          </app-table>
                        </div>

                        <div *ngIf="!loadingCustomers && customers.length === 0" class="alert alert-info">
                          <i class="fas fa-info-circle me-2"></i>
                          Nenhum cliente encontrado. Cadastre clientes antes de realizar agendamentos.
                        </div>
                      </div>

                      <div *ngIf="scheduleSuccess && selectedTimeSlot && selectedCustomer"
                        class="alert alert-success mt-3 mb-0">
                        <i class="fas fa-check me-2"></i>
                        Agendamento criado para <strong>{{ selectedCustomer.name }}</strong> em {{
                        selectedPreviewDay.fullDate | date: 'dd/MM/yyyy' }} às {{ selectedTimeSlot.start }}.
                      </div>

                      <div *ngIf="scheduleError" class="alert alert-danger mt-3 mb-0">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        {{ scheduleError }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="alert alert-info mt-4 mb-0">
                  <i class="fas fa-info-circle me-1"></i>
                  <strong>{{ selectedPreviewDay.timeSlots.length }}</strong> horários disponíveis
                  <span *ngIf="attendancesPerSlot > 1">
                    ({{ selectedPreviewDay.timeSlots.length * attendancesPerSlot }} vagas totais)
                  </span>
                </div>
              </div>
            </div>

            <!-- Dia Indisponível -->
            <div *ngIf="!selectedPreviewDay.available && !loadingDayAvailability">
              <div class="alert alert-warning mb-0">
                <div class="d-flex align-items-start">
                  <i class="fas fa-exclamation-triangle me-3 mt-1" style="font-size: 2rem;"></i>
                  <div>
                    <h5 class="alert-heading mb-2">Dia Indisponível</h5>
                    <p class="mb-0">
                      <span *ngIf="selectedPreviewDay.reason === 'holiday'">
                        Este dia foi excluído por ser um <strong>Feriado Nacional</strong>.
                      </span>
                      <span *ngIf="selectedPreviewDay.reason === 'excluded'">
                        Este dia foi <strong>excluído especificamente</strong> das configurações da agenda ou não possui
                        mais vagas disponíveis.
                      </span>
                      <span *ngIf="selectedPreviewDay.reason === 'weekday'">
                        Este dia da semana <strong>não está configurado</strong> para atendimento.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lista de Agendamentos Existentes -->
        <div class="card shadow-sm mt-4" *ngIf="dayAppointments.length > 0 || loadingAppointments">
          <div class="card-header text-white" style="background-color: #3A4D56;">
            <h5 class="mb-0">
              <i class="fas fa-list me-2"></i>
              Agendamentos do Dia
              <span class="badge bg-light text-dark ms-2" *ngIf="!loadingAppointments">{{ dayAppointments.length
                }}</span>
            </h5>
          </div>
          <div class="card-body">
            <!-- Loading -->
            <div *ngIf="loadingAppointments" class="text-center py-3">
              <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
              <p class="mt-2 text-muted">Carregando agendamentos...</p>
            </div>

            <!-- Lista de Appointments -->
            <div *ngIf="!loadingAppointments && dayAppointments.length > 0">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Horário</th>
                      <th *ngIf="showPartnerWorkshopColumn">Oficina</th>
                      <th>Cliente</th>
                      <th>Placa</th>
                      <th>Condutor</th>
                      <th>Assunto</th>
                      <th>Status</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let app of paginatedAppointments" [class.table-warning]="isPartnerAppointment(app)">
                      <td>
                        <i class="fas fa-clock me-2 text-primary"></i>
                        <strong>{{ formatAppointmentTime(app.StartTime) }} – {{ formatAppointmentTime(app.EndTime) }}</strong>
                        <span class="badge bg-info ms-1" *ngIf="isPartnerAppointment(app) && !isGuinchoSolicitacao(app)">Parceiro</span>
                        <span class="badge bg-info text-dark ms-1" *ngIf="isGuinchoSolicitacao(app)">Guincho</span>
                        <span class="badge bg-danger ms-1" *ngIf="isNewAppointment(app)">Novo</span>
                      </td>
                      <td *ngIf="showPartnerWorkshopColumn">
                        <span class="fw-semibold">{{ providerNameOf(app) }}</span>
                      </td>
                      <td [title]="app.Subject">
                        {{ (app.Subject || '').length > 50 ? (app.Subject | slice:0:50) + '...' : app.Subject }}
                      </td>
                      <td>{{ app.Plate || '—' }}</td>
                      <td>{{ app.DriverName || '—' }}</td>
                      <td>{{ app.Description || '-' }}</td>
                      <td>
                        <span class="badge" [class.bg-success]="app.Status === 'Agendado'"
                          [class.bg-warning]="app.Status === 'Confirmado' || app.Status === 'AguardandoAnalise' || app.Status === 'Aguardando Análise'"
                          [class.bg-info]="app.Status === 'Em Andamento' || app.Status === 'Compareceu'"
                          [class.bg-secondary]="app.Status === 'Concluído'"
                          [class.bg-danger]="app.Status === 'Cancelado' || app.Status === 'Não compareceu'"
                          [class.bg-primary]="app.Status === 'Gerado OS'">
                          {{ app.Status }}
                        </span>
                      </td>
                      <td class="text-center">
                        <div class="btn-group" role="group" *ngIf="app.Id">
                          <!-- Visualizar: sempre disponível -->
                          <button type="button" class="btn btn-sm btn-outline-info"
                            (click)="openAppointmentDetailsModal(app)" title="Visualizar detalhes">
                            <i class="fas fa-eye"></i>
                          </button>

                          <ng-container *ngIf="app.Status !== 'Gerado OS'">
                          <ng-container *ngIf="!isAttendanceLocked(app)">
                            <!-- Botão de Alterar Status -->
                            <button type="button" class="btn btn-sm btn-outline-primary"
                              [disabled]="updatingStatusAppointmentId === app.Id"
                              (click)="openStatusSelectionModal(app)" title="Alterar status">
                              <i class="fas fa-spinner fa-spin" *ngIf="updatingStatusAppointmentId === app.Id"></i>
                              <i class="fas fa-edit" *ngIf="updatingStatusAppointmentId !== app.Id"></i>
                            </button>

                            <!-- Botão de Excluir -->
                            <button type="button" class="btn btn-sm btn-outline-danger"
                              [disabled]="deletingAppointmentId === app.Id" (click)="deleteAppointment(app)"
                              title="Excluir agendamento">
                              <i class="fas fa-spinner fa-spin" *ngIf="deletingAppointmentId === app.Id"></i>
                              <i class="fas fa-trash" *ngIf="deletingAppointmentId !== app.Id"></i>
                            </button>
                          </ng-container>

                          <button type="button" class="btn btn-sm btn-outline-info"
                            *ngIf="isB2bAttendanceEligible(app) && (app.Status === 'Agendado' || app.Status === 'Confirmado')"
                            [disabled]="updatingStatusAppointmentId === app.Id"
                            (click)="updateAppointmentStatus(app, 'Compareceu')" title="Compareceu">
                            <i class="fas fa-user-check"></i>
                          </button>

                          <button type="button" class="btn btn-sm btn-outline-secondary"
                            *ngIf="isB2bAttendanceEligible(app) && (app.Status === 'Agendado' || app.Status === 'Confirmado')"
                            [disabled]="updatingStatusAppointmentId === app.Id"
                            (click)="updateAppointmentStatus(app, 'Não compareceu')" title="Não compareceu">
                            <i class="fas fa-user-times"></i>
                          </button>

                          <!-- Compareceu: criar orçamento B2B (vira OS) -->
                          <button type="button" class="btn btn-sm btn-outline-success"
                            *ngIf="canCreateBudgetFromAppointment(app)"
                            (click)="createBudgetFromAppointment(app)" title="Criar orçamento">
                            <i class="fas fa-file-invoice-dollar"></i>
                          </button>

                          <!-- Legacy: Gerar OS pura (sem orçamento) quando Confirmado -->
                          <button type="button" class="btn btn-sm btn-outline-success"
                            *ngIf="selectedSchedule?.CanExternalLink && app.Status === 'Confirmado' && !app.ServiceOrderId"
                            (click)="generateServiceOrder(app)" title="Gerar OS">
                            <i class="fas fa-file-invoice"></i>
                          </button>
                          </ng-container>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Paginação -->
              <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalAppointmentsPages > 1">
                <div class="text-muted small">
                  Mostrando {{ (appointmentsPage - 1) * appointmentsPageSize + 1 }} -
                  {{ Math.min(appointmentsPage * appointmentsPageSize, dayAppointments.length) }}
                  de {{ dayAppointments.length }} agendamentos
                </div>
                <nav>
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" [class.disabled]="appointmentsPage === 1">
                      <button class="page-link" (click)="prevAppointmentsPage()" [disabled]="appointmentsPage === 1">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                    </li>
                    <li class="page-item" *ngFor="let page of [].constructor(totalAppointmentsPages); let i = index"
                      [class.active]="appointmentsPage === i + 1">
                      <button class="page-link" (click)="goToAppointmentsPage(i + 1)">
                        {{ i + 1 }}
                      </button>
                    </li>
                    <li class="page-item" [class.disabled]="appointmentsPage === totalAppointmentsPages">
                      <button class="page-link" (click)="nextAppointmentsPage()"
                        [disabled]="appointmentsPage === totalAppointmentsPages">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <div *ngIf="!loadingAppointments && dayAppointments.length === 0" class="alert alert-info mb-0">
              <i class="fas fa-info-circle me-2"></i>
              Nenhum agendamento encontrado para este dia.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Sucesso -->
  <app-modal [isOpen]="showSuccessModal" [title]="'Agendamento Confirmado!'" [size]="'md'" [closable]="true"
    (close)="closeSuccessModal()">

    <div class="text-center py-4">
      <div class="mb-4">
        <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
      </div>

      <h4 class="mb-3">Agendamento realizado com sucesso!</h4>

      <div class="alert alert-success" *ngIf="selectedCustomer">
        <p class="mb-2">
          <strong>Cliente:</strong> {{ selectedCustomer.name }}
        </p>
        <p class="mb-2" *ngIf="selectedPreviewDay">
          <strong>Data:</strong> {{ selectedPreviewDay.fullDate | date: 'dd/MM/yyyy' }}
        </p>
        <p class="mb-2" *ngIf="isB2bBookingFlow && b2bBooking.selectedVehicle">
          <strong>Placa:</strong> {{ b2bBooking.selectedVehicle.plate || '—' }}
          · <strong>Condutor:</strong> {{ b2bBooking.selectedVehicle.driverName }}
        </p>
        <p class="mb-0" *ngIf="selectedTimeSlot">
          <strong>Horário:</strong> {{ selectedTimeSlot.start }} - {{ selectedTimeSlot.end }}
        </p>
      </div>

      <p class="text-muted">O cliente foi notificado sobre o agendamento.</p>
    </div>

    <div slot="footer" class="d-flex justify-content-center gap-2">
      <button type="button" class="btn btn-primary" (click)="closeSuccessModal()">
        <i class="fas fa-check me-2"></i>
        Entendido
      </button>
    </div>
  </app-modal>

  <!-- Modal de Seleção de Status -->
  <app-modal [isOpen]="showStatusSelectionModal" [title]="'Alterar Status do Agendamento'" [size]="'md'"
    [closable]="true" (close)="closeStatusSelectionModal()">

    <div class="py-3">
      <p class="text-muted mb-3" *ngIf="selectedAppointmentForStatus">
        Selecione o novo status para <strong>{{ selectedAppointmentForStatus.Subject }}</strong>.
      </p>

      <div class="d-grid gap-2">
        <button type="button" class="btn"
          [class.btn-outline-primary]="selectedAppointmentForStatus?.Status !== status"
          [class.btn-primary]="selectedAppointmentForStatus?.Status === status"
          *ngFor="let status of availableStatuses" (click)="selectStatusFromModal(status)">
          <i class="fas fa-check me-2" *ngIf="selectedAppointmentForStatus?.Status === status"></i>
          {{ status }}
        </button>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeStatusSelectionModal()">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
    </div>
  </app-modal>

  <!-- Modal de Busca por CPF/CNPJ -->
  <app-modal [isOpen]="showSearchModal" [title]="'Buscar Agendamento por CPF/CNPJ'" [size]="'lg'" [closable]="true"
    (close)="closeSearchModal()">

    <div class="py-2">
      <p class="text-muted mb-3">
        Informe o CPF ou CNPJ para localizar agendamentos e abrir diretamente o dia no calendário.
      </p>

      <div class="row g-2 align-items-center">
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="Digite CPF ou CNPJ" [(ngModel)]="documentSearchTerm"
            (keyup.enter)="searchAppointmentsByDocument()">
        </div>
        <div class="col-md-3 d-grid">
          <button type="button" class="btn btn-primary" (click)="searchAppointmentsByDocument()"
            [disabled]="searchingByDocument">
            <i class="fas fa-spinner fa-spin me-2" *ngIf="searchingByDocument"></i>
            <i class="fas fa-search me-2" *ngIf="!searchingByDocument"></i>
            Buscar
          </button>
        </div>
      </div>

      <div *ngIf="searchByDocumentError" class="alert alert-warning mt-3 mb-0">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ searchByDocumentError }}
      </div>

      <div *ngIf="!searchingByDocument && searchByDocumentResults.length > 0" class="mt-3">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>Data</th>
                <th>Horário</th>
                <th>Cliente</th>
                <th>Placa</th>
                <th>Condutor</th>
                <th>Status</th>
                <th class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let app of searchByDocumentResults">
                <td>{{ app.Date | date: 'dd/MM/yyyy' }}</td>
                <td>{{ app.StartTime.substring(0, 5) }} - {{ app.EndTime.substring(0, 5) }}</td>
                <td>{{ app.Subject }}</td>
                <td>{{ app.Plate || '—' }}</td>
                <td>{{ app.DriverName || '—' }}</td>
                <td>
                  <span class="badge" [class.bg-success]="app.Status === 'Agendado'"
                    [class.bg-warning]="app.Status === 'Confirmado'"
                    [class.bg-danger]="app.Status === 'Cancelado'"
                    [class.bg-secondary]="app.Status !== 'Agendado' && app.Status !== 'Confirmado' && app.Status !== 'Cancelado'">
                    {{ app.Status }}
                  </span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="goToAppointmentDay(app)">
                    <i class="fas fa-calendar-day me-2"></i>
                    Ir para o dia
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeSearchModal()">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
    </div>
  </app-modal>

  <!-- Modal de Motivo de Cancelamento / Recusa parceiro -->
  <app-modal [isOpen]="showCancelReasonModal"
    [title]="cancelReasonMode === 'reject-partner' ? 'Motivo da recusa (parceiro)' : 'Motivo do Cancelamento'"
    [size]="'md'" [closable]="true"
    (close)="closeCancelReasonModal()">

    <div class="py-3">
      <p class="text-muted mb-3">
        {{ cancelReasonMode === 'reject-partner'
          ? 'Informe o motivo da recusa após o contato com a oficina parceira. O portal verá o agendamento como cancelado.'
          : 'Por favor, informe o motivo do cancelamento deste agendamento.' }}
      </p>

      <div class="mb-3">
        <label for="cancelReason" class="form-label">
          Motivo <span class="text-danger">*</span>
        </label>
        <textarea id="cancelReason" class="form-control" rows="4" [(ngModel)]="cancelReason"
          [class.is-invalid]="cancelReasonError"
          [placeholder]="cancelReasonMode === 'reject-partner'
            ? 'Digite o motivo da recusa (mínimo 5 caracteres)'
            : 'Digite o motivo do cancelamento (mínimo 5 caracteres)'"
          maxlength="500"></textarea>
        <div class="invalid-feedback" *ngIf="cancelReasonError">
          {{ cancelReasonError }}
        </div>
        <small class="text-muted">{{ cancelReason.length }}/500 caracteres</small>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeCancelReasonModal()">
        <i class="fas fa-times me-2"></i>
        Cancelar
      </button>
      <button type="button" class="btn btn-danger" (click)="confirmCancelReason()"
        [disabled]="!cancelReason.trim()">
        <i class="fas fa-check me-2"></i>
        {{ cancelReasonMode === 'reject-partner' ? 'Confirmar recusa' : 'Confirmar Cancelamento' }}
      </button>
    </div>
  </app-modal>

  <!-- Modal: data/hora do comparecimento ou falta -->
  <app-modal [isOpen]="showAttendanceRecordedAtModal"
    [title]="pendingAttendanceUpdate?.status === 'Compareceu' ? 'Data do comparecimento' : 'Data do registro de falta'"
    [size]="'md'" [closable]="true"
    (close)="closeAttendanceRecordedAtModal()">

    <div class="py-3">
      <p class="text-muted mb-3">
        Informe quando o cliente {{ pendingAttendanceUpdate?.status === 'Compareceu' ? 'compareceu' : 'não compareceu' }}.
        Use para lançamentos retroativos.
      </p>

      <div class="mb-3">
        <label for="attendanceRecordedAt" class="form-label">
          Data e hora <span class="text-danger">*</span>
        </label>
        <input id="attendanceRecordedAt" type="datetime-local" class="form-control"
          [(ngModel)]="attendanceRecordedAt"
          [class.is-invalid]="!!attendanceRecordedAtError">
        <div class="invalid-feedback" *ngIf="attendanceRecordedAtError">
          {{ attendanceRecordedAtError }}
        </div>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeAttendanceRecordedAtModal()">
        <i class="fas fa-times me-2"></i>
        Cancelar
      </button>
      <button type="button" class="btn btn-primary" (click)="confirmAttendanceRecordedAt()"
        [disabled]="!attendanceRecordedAt">
        <i class="fas fa-check me-2"></i>
        Confirmar
      </button>
    </div>
  </app-modal>

  <!-- Modal: reagendar / trocar oficina parceira -->
  <app-modal [isOpen]="showPartnerRescheduleModal"
    title="Reagendar oficina parceira"
    [size]="'lg'"
    [closable]="true"
    (close)="closePartnerRescheduleModal()">

    <div class="py-3" *ngIf="partnerRescheduleApp as app">
      <p class="text-muted mb-3">
        Ajuste oficina, data e horário para a placa <code>{{ app.Plate || '—' }}</code>
        <span *ngIf="partnerRescheduleVehicleUf"> · UF <strong>{{ partnerRescheduleVehicleUf }}</strong></span>.
        Parceiro atual: <strong>{{ providerNameOf(app) }}</strong>.
        A solicitação permanece em análise até você confirmar.
      </p>

      <div *ngIf="partnerRescheduleProvidersLoading" class="text-muted mb-3">
        <i class="fas fa-spinner fa-spin me-1"></i> Carregando oficinas da região...
      </div>

      <div class="mb-3" *ngIf="!partnerRescheduleProvidersLoading">
        <label class="form-label" for="partnerRescheduleSelect">Oficina parceira <span class="text-danger">*</span></label>
        <select id="partnerRescheduleSelect" class="form-select"
          [(ngModel)]="partnerRescheduleProviderId"
          [disabled]="partnerRescheduleProviders.length === 0 || partnerActionId != null">
          <option [ngValue]="null" disabled>Selecione...</option>
          <option *ngFor="let p of partnerRescheduleProviders" [ngValue]="p.id">
            {{ p.tradeName }}<span *ngIf="p.servedStates"> · UF {{ p.servedStates }}</span>
          </option>
        </select>
        <div class="form-text">Somente parceiros que atendem a UF do veículo.</div>
      </div>

      <div class="row g-3">
        <div class="col-12">
          <label class="form-label" for="partnerRescheduleDate">Nova data <span class="text-danger">*</span></label>
          <input id="partnerRescheduleDate" type="date" class="form-control"
            [(ngModel)]="partnerRescheduleDate"
            [min]="partnerRescheduleMinDate"
            [class.is-invalid]="!!partnerRescheduleError && !partnerRescheduleDate">
        </div>
        <div class="col-md-6">
          <label class="form-label" for="partnerRescheduleStart">Início <span class="text-danger">*</span></label>
          <select id="partnerRescheduleStart" class="form-select"
            [(ngModel)]="partnerRescheduleStart"
            (ngModelChange)="onPartnerRescheduleStartChange()">
            <option *ngFor="let t of partnerTimeChoices" [value]="t">{{ t }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label" for="partnerRescheduleEnd">Fim <span class="text-danger">*</span></label>
          <select id="partnerRescheduleEnd" class="form-select" [(ngModel)]="partnerRescheduleEnd">
            <option *ngFor="let t of partnerTimeChoices" [value]="t">{{ t }}</option>
            <option value="18:00">18:00</option>
          </select>
        </div>
      </div>

      <div class="form-check mt-3">
        <input class="form-check-input" type="checkbox" id="partnerRescheduleAndConfirm"
          [(ngModel)]="partnerRescheduleAndConfirm">
        <label class="form-check-label" for="partnerRescheduleAndConfirm">
          Salvar e confirmar (status Agendado)
        </label>
      </div>

      <div class="alert alert-danger mt-3 mb-0 py-2" *ngIf="partnerRescheduleError">
        {{ partnerRescheduleError }}
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closePartnerRescheduleModal()"
        [disabled]="partnerActionId != null">
        Voltar
      </button>
      <button type="button" class="btn btn-primary" (click)="savePartnerReschedule()"
        [disabled]="partnerActionId != null || partnerRescheduleProvidersLoading || !partnerRescheduleProviderId">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="partnerActionId != null"></i>
        <i class="fas fa-save me-1" *ngIf="partnerActionId == null"></i>
        {{ partnerRescheduleAndConfirm ? 'Salvar e confirmar' : 'Salvar horário' }}
      </button>
    </div>
  </app-modal>

  <!-- Modal de Link Externo -->
  <app-modal [isOpen]="showExternalLinkModal" [title]="'Gerar Link de Agendamento Externo'" [size]="'lg'" [closable]="true"
    (close)="closeExternalLinkModal()">
    <div class="py-3">
      <p class="text-muted mb-3">
        Selecione o <strong>Cliente</strong> e o <strong>Prestador</strong> para gerar o link de agendamento externo.
      </p>

      <div class="row g-3">
        <div class="col-md-6">
          <label for="linkCustomerSelect" class="form-label fw-semibold">Cliente <span class="text-danger">*</span></label>
          <select id="linkCustomerSelect" class="form-select"
            [(ngModel)]="linkSelectedCustomerId"
            [disabled]="loadingCustomers || generatingLink || !!generatedExternalLink">
            <option [ngValue]="null" disabled>Selecione um cliente...</option>
            <option *ngFor="let c of customers" [ngValue]="c.id">
              {{ c.name }}<span *ngIf="c.documentNumber"> - {{ c.documentNumber }}</span>
            </option>
          </select>
          <small *ngIf="loadingCustomers" class="text-muted">
            <i class="fas fa-spinner fa-spin me-1"></i>Carregando clientes...
          </small>
        </div>

        <div class="col-md-6">
          <label for="linkProviderSelect" class="form-label fw-semibold">Prestador <span class="text-danger">*</span></label>
          <select id="linkProviderSelect" class="form-select"
            [(ngModel)]="linkSelectedProviderId"
            [disabled]="loadingProviders || generatingLink || !!generatedExternalLink">
            <option [ngValue]="null" disabled>Selecione um prestador...</option>
            <option *ngFor="let p of providers" [ngValue]="p.id">
              {{ p.tradeName || p.companyName }}<span *ngIf="p.cnpj"> - {{ p.cnpj }}</span>
            </option>
          </select>
          <small *ngIf="loadingProviders" class="text-muted">
            <i class="fas fa-spinner fa-spin me-1"></i>Carregando prestadores...
          </small>
        </div>
      </div>

      <div *ngIf="generatingLink" class="text-center mt-4">
        <i class="fas fa-spinner fa-spin me-2"></i> Gerando link...
      </div>

      <div *ngIf="generatedExternalLink" class="mt-4">
        <label class="form-label fw-semibold">Link gerado</label>
        <div class="input-group">
          <input type="text" class="form-control" [value]="generatedExternalLink" readonly>
          <button class="btn btn-outline-secondary" type="button" (click)="copyExternalLink()" title="Copiar para a área de transferência">
            <i class="fas fa-copy"></i>
          </button>
        </div>
        <small class="text-muted d-block mt-2">
          Compartilhe este link com a pessoa que irá realizar o agendamento externo.
        </small>
      </div>
    </div>
    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeExternalLinkModal()">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
      <button type="button" class="btn btn-primary" (click)="generateExternalLink()"
        *ngIf="!generatedExternalLink"
        [disabled]="!linkSelectedCustomerId || !linkSelectedProviderId || generatingLink">
        <i class="fas fa-link me-2"></i>
        Gerar Link
      </button>
    </div>
  </app-modal>

  <!-- Modal de Detalhes do Agendamento -->
  <app-modal [isOpen]="showAppointmentDetailsModal" [title]="'Detalhes do Agendamento'" [size]="'lg'" [closable]="true"
    (close)="closeAppointmentDetailsModal()">
    <div class="py-2" *ngIf="selectedAppointmentDetails as app">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Data</label>
          <div>{{ app.Date | date: 'dd/MM/yyyy' }}</div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Horário</label>
          <div>
            <i class="fas fa-clock me-2 text-primary"></i>
            {{ app.StartTime.substring(0, 5) }} - {{ app.EndTime.substring(0, 5) }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Cliente</label>
          <div>{{ app.Subject || '-' }}</div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Status</label>
          <div>
            <span class="badge"
              [class.bg-success]="app.Status === 'Agendado'"
              [class.bg-warning]="app.Status === 'Confirmado' || app.Status === 'AguardandoAnalise' || app.Status === 'Aguardando Análise'"
              [class.bg-info]="app.Status === 'Em Andamento' || app.Status === 'Compareceu'"
              [class.bg-secondary]="app.Status === 'Concluído'"
              [class.bg-danger]="app.Status === 'Cancelado' || app.Status === 'Não compareceu'"
              [class.bg-primary]="app.Status === 'Gerado OS'">
              {{ app.Status }}
            </span>
          </div>
        </div>
        <div class="col-md-6" *ngIf="app.ServiceOrderId">
          <label class="form-label fw-semibold text-muted small mb-1">OS vinculada</label>
          <div>
            <i class="fas fa-wrench me-2 text-primary"></i>
            #{{ app.ServiceOrderId }}
          </div>
        </div>
        <div class="col-md-6" *ngIf="app.Plate">
          <label class="form-label fw-semibold text-muted small mb-1">Placa</label>
          <div>{{ app.Plate }}</div>
        </div>
        <div class="col-md-6" *ngIf="app.DriverName">
          <label class="form-label fw-semibold text-muted small mb-1">Condutor</label>
          <div>{{ app.DriverName }}</div>
        </div>
        <div class="col-md-6" *ngIf="app.B2BContractId">
          <label class="form-label fw-semibold text-muted small mb-1">Contrato B2B</label>
          <div>#{{ app.B2BContractId }}</div>
        </div>
        <div class="col-md-6" *ngIf="app.ExternalServiceProviderId || app.ExternalServiceProviderName">
          <label class="form-label fw-semibold text-muted small mb-1">Oficina parceira</label>
          <div>{{ app.ExternalServiceProviderName || ('#' + app.ExternalServiceProviderId) }}</div>
        </div>
        <div class="col-md-6" *ngIf="app.AttendedAt">
          <label class="form-label fw-semibold text-muted small mb-1">Comparecimento registrado em</label>
          <div>{{ app.AttendedAt | date: 'dd/MM/yyyy HH:mm' }}</div>
        </div>
        <div class="col-12">
          <label class="form-label fw-semibold text-muted small mb-1">Assunto / Descrição</label>
          <div class="appointment-description-box p-3 border rounded bg-light"
            style="white-space: pre-wrap; word-break: break-word;">
            {{ app.Description || '-' }}
          </div>
        </div>
        <div class="col-12">
          <label class="form-label fw-semibold text-muted small mb-1">Observação</label>
          <div class="appointment-description-box p-3 border rounded"
            [class.bg-light]="app.PartnerNotes"
            [class.bg-white]="!app.PartnerNotes"
            style="white-space: pre-wrap; word-break: break-word;">
            <ng-container *ngIf="app.PartnerNotes; else noPartnerNotes">{{ app.PartnerNotes }}</ng-container>
            <ng-template #noPartnerNotes>
              <span class="text-muted fst-italic">Sem observação</span>
            </ng-template>
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Criado por</label>
          <div>{{ app.CreatedBy || '—' }}</div>
          <small class="text-muted" *ngIf="app.CreatedAt">{{ app.CreatedAt | date: 'dd/MM/yyyy HH:mm' }}</small>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold text-muted small mb-1">Atualizado por</label>
          <div>{{ app.UpdatedBy || '—' }}</div>
          <small class="text-muted" *ngIf="app.UpdatedAt">{{ app.UpdatedAt | date: 'dd/MM/yyyy HH:mm' }}</small>
        </div>
        <div class="col-md-6" *ngIf="app.DeletedBy || app.DeletedAt">
          <label class="form-label fw-semibold text-muted small mb-1">Excluído por</label>
          <div>{{ app.DeletedBy || '—' }}</div>
          <small class="text-muted" *ngIf="app.DeletedAt">{{ app.DeletedAt | date: 'dd/MM/yyyy HH:mm' }}</small>
        </div>
        <div class="col-12">
          <label class="form-label fw-semibold text-muted small mb-1">
            <i class="fas fa-history me-1"></i> Histórico
          </label>
          <div *ngIf="loadingAppointmentHistory" class="text-muted small">Carregando histórico…</div>
          <ul class="list-unstyled appointment-history mb-0" *ngIf="!loadingAppointmentHistory && appointmentHistory.length">
            <li class="border-start border-3 border-primary ps-2 mb-2" *ngFor="let h of appointmentHistory">
              <div class="small fw-semibold">{{ h.Message }}</div>
              <div class="text-muted" style="font-size:0.75rem">
                {{ h.CreatedBy || '—' }} · {{ h.CreatedAt | date:'dd/MM/yyyy HH:mm' }}
                <span class="badge bg-light text-dark ms-1">{{ h.EventType }}</span>
              </div>
            </li>
          </ul>
          <p class="text-muted small mb-0" *ngIf="!loadingAppointmentHistory && !appointmentHistory.length">
            Nenhum evento registrado ainda.
          </p>
        </div>
      </div>
    </div>
    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeAppointmentDetailsModal()">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
    </div>
  </app-modal>
</app-side-menu>